import SideBySideRecordsTable from "./SideBySideRecordsTable";
import PageMeta from "./PageMeta";

export default function RecordsPage() {
  return (
    <>
      <PageMeta
        title="RSAA Catch & Release Records | Redruth Sea Angling Association"
        description="Official catch and release records for Redruth Sea Angling Association, Cornwall's sea angling club since 1962."
        keywords="RSAA catch and release records, sea angling records Cornwall, Redruth Sea Angling Association records"
        url="https://www.redruthseaanglingassociation.co.uk/records"
      />
      <SideBySideRecordsTable
        title="RSAA Catch & Release Records"
        excelFile="/rsaa_catch_rlease_record.xlsx"
        recordType="catchAndRelease"
      />
    </>
  );
}
